import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import type { WorkspaceInfoInput, YourDetailsInput } from '../schemas/onboardingSchemas';

// Draft state for the 3-screen onboarding flow. Zustand persist saves to
// localStorage so Back/Next and a hard refresh preserve whatever the user
// typed. The draft is cleared by `clear()` when onboarding completes.
//
// yourDetails: firstName + lastName + workspaceName (all required, collected on step 1).
// workspaceInfo: industry + teamSize (optional analytics, collected on step 2).

type YourDetailsDraft = Partial<YourDetailsInput>;
type WorkspaceInfoDraft = Partial<WorkspaceInfoInput>;

interface OnboardingState {
  yourDetails: YourDetailsDraft;
  workspaceInfo: WorkspaceInfoDraft;
  setYourDetails: (data: YourDetailsDraft) => void;
  setWorkspaceInfo: (data: WorkspaceInfoDraft) => void;
  clear: () => void;
}

export const useOnboardingStore = create<OnboardingState>()(
  persist(
    (set) => ({
      yourDetails: {},
      workspaceInfo: {},
      setYourDetails: (data) => set((s) => ({ yourDetails: { ...s.yourDetails, ...data } })),
      setWorkspaceInfo: (data) => set((s) => ({ workspaceInfo: { ...s.workspaceInfo, ...data } })),
      clear: () => set({ yourDetails: {}, workspaceInfo: {} }),
    }),
    {
      name: 'signcare.onboarding',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
